import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import axios from 'axios'
import qs from 'qs'
import message from 'antd/lib/message'

import l8n from 'l8n'

import { addSubmitForm, deleteSubmitForm, getCurrentUser } from 'ducks/app'
import { USER_STATUS_NOT_ACTIVE, USER_STATUS_ACTIVATION_REQUESTED } from 'ducks/app'
import { setUser, getUser } from 'ducks/app'
import { baseUrl } from 'scripts/env'

export const REDUCER = 'details'
const NS = `@@${REDUCER}/`

export const TYPE_COMPANY = 'ooo'
export const TYPE_PERSONAL = 'ip'
export const DIRECTOR_TITLE_GENDIR = 'gendir'
export const DIRECTOR_TITLE_DIR = 'dir'
export const DIRECTOR_TITLE_IP = 'ip'
export const DIRECTOR_REASON_USTAV = 'ustav'
export const DIRECTOR_REASON_DOVERENNOST = 'doverennost'
export const DIRECTOR_REASON_IP = 'svidetelstvo'

export const fetchRequest = createAction(`${NS}FETCH_REQUEST`)
export const fetchSuccess = createAction(`${NS}FETCH_SUCCESS`)
export const fetchFailure = createAction(`${NS}FETCH_FAILURE`)

export const sendRequest = createAction(`${NS}SEND_REQUEST`)
export const sendSuccess = createAction(`${NS}SEND_SUCCESS`)
export const sendFailure = createAction(`${NS}SEND_FAILURE`)

export const activateRequest = createAction(`${NS}ACTIVATE_REQUEST`)
export const activateSuccess = createAction(`${NS}ACTIVATE_SUCCESS`)
export const activateFailure = createAction(`${NS}ACTIVATE_FAILURE`)

export const changeRequisitesRequest = createAction(`${NS}CHANGE_REQUISITES_REQUEST`)
export const changeRequisitesSuccess = createAction(`${NS}CHANGE_REQUISITES_SUCCESS`)
export const changeRequisitesFailure = createAction(`${NS}CHANGE_REQUISITES_FAILURE`)

export const change = createAction(`${NS}CHANGE`)

const initialState = {
  isLoading: false,
  activationLoading: false,
  changeRequisitesDisabled: false,
  paypalEmail: null,
  data: {
    company_type: {value: TYPE_COMPANY},
    company_name: {value: null},
    inn: {value: null},              
    kpp: {value: null},
    ogrn: {value: null},                 
    ogrnip: {value: null},               
    bank: {value: null},                 
    rs: {value: null},                   
    ks: {value: null},                   
    ur_address: {value: null},           
    fiz_address: {value: null},          
    phone: {value: null},                
    director_title: {value: DIRECTOR_TITLE_GENDIR},       
    director_reason: {value: DIRECTOR_REASON_USTAV},      
    director_first_name: {value: null},  
    director_middle_name: {value: null}, 
    director_last_name: {value: null},   
    bik: {value: null},                  
    paypal_email: {value: null},         
    contact_person: {value: null}, 
    eula: {value: false}, 
    current_password: {value: null},
    vat: {value: null},
  }
}

export const activate = () => async (dispatch, getState) => {
  const state = getState()
  const user = getCurrentUser(state)
  if (user.status !== USER_STATUS_NOT_ACTIVE){
    return false
  }

  dispatch(activateRequest())
  var response = await axios({
      method: 'POST',
      url: `${baseUrl}/user/request-activation`
  })

  if (_.get(response, 'data.ok', false) === false) {
    dispatch(activateFailure())
    return false
  }

  message.success(l8n.p_activation_request_sent)
  dispatch(activateSuccess())
  dispatch(setUser({ status: USER_STATUS_ACTIVATION_REQUESTED }))
  return true
}

export const changeRequisites = () => async (dispatch, getState) => {
  const state = getState()

  dispatch(changeRequisitesRequest())

  function openJivoChatAndSendMessage() {
    window.jivo_api.open();

    if (state.changeRequisitesDisabled) {
      dispatch(changeRequisitesSuccess())
      return
    }

    const sendResult = window.jivo_api.sendMessage(l8n['p_help_change_requisites']);
    dispatch(
      sendResult.result === 'ok' ? changeRequisitesSuccess() : changeRequisitesFailure()
    );
  }

  if (window.jivo_api) {
    openJivoChatAndSendMessage();
  } else {
    window.jivo_onLoadCallback = openJivoChatAndSendMessage;
  }

  return true
}

export const fetch = () => async (dispatch) => {
  dispatch(getUser())
  dispatch(fetchRequest())
  var response = await axios({
      method: 'GET',
      url: `${baseUrl}/user/${REDUCER}`
  })

  const details = _.get(response, `data.${REDUCER}`, false)
  if (details === false) {
    dispatch(fetchFailure())
    return false
  }

  dispatch(fetchSuccess(details))
  dispatch(getUser())
  return true
}

export const send = async (details, dispatch, getState) => {
  dispatch(sendRequest())
  var response = await axios({
      method: 'POST',
      url: `${baseUrl}/user/details`,
      data: qs.stringify(details)
  });

  if (_.get(response, 'data.ok', false) === false) {
      dispatch(sendFailure())
      message.error(l8n.req_not_saved);
      return false
  }

  dispatch(sendSuccess())
  message.success(l8n.req_saved);
  dispatch(getUser())
  return true
}

export const submit = details => async (dispatch, getState) => {
  dispatch(addSubmitForm(REDUCER))
  await send(details, dispatch, getState)
  dispatch(deleteSubmitForm(REDUCER))
}

export default createReducer(
  {
    [fetchRequest]: (state) => ({ ...state, isLoading : true }),
    [fetchSuccess]: (state, flatData) => { 
      if (!!flatData) {
        // Добавляем уровень вложенности, потому что так так работает Form.createFormField
        const newData = _.mapValues(_.clone(flatData), (val) => ({ value: val }))
        return {...state, data: {...state.data, ...initialState.data, ...newData}, isLoading: false, paypalEmail: flatData.paypal_email}
      } else {
        return {...state, ...initialState}
      }
    },
    [fetchFailure]: (state) => ({ ...state, isLoading : false }),

    [activateRequest]: (state) => ({ ...state, activationLoading : true }),
    [activateSuccess]: (state) => ({ ...state, activationLoading : false }),
    [activateFailure]: (state) => ({ ...state, activationLoading : false }),

    [sendRequest]: (state) => ({ ...state }),
    [sendSuccess]: (state) => ({ ...state }),
    [sendFailure]: (state) => ({ ...state }),

    [changeRequisitesRequest]: (state) => ({ ...state, changeRequisitesDisabled: true }),
    [changeRequisitesSuccess]: (state) => ({ ...state, changeRequisitesDisabled: false }),
    [changeRequisitesFailure]: (state) => ({ ...state, changeRequisitesDisabled: false }),

    [change]: (state, data) => {
      let newData = Object.assign({}, data)

      if (!!data.company_type) {
        const type = data.company_type.value

        if (type === TYPE_COMPANY) {
          if (state.data.director_title.value === DIRECTOR_TITLE_IP) {
            _.set(newData, 'director_title.value', DIRECTOR_TITLE_GENDIR)
          }
          if (state.data.director_reason.value === DIRECTOR_REASON_IP) {
            _.set(newData, 'director_reason.value', DIRECTOR_REASON_USTAV)
          }
    
        } else if (type === TYPE_PERSONAL) {
          if (state.data.director_title.value !== DIRECTOR_TITLE_IP) {
            _.set(newData, 'director_title.value', DIRECTOR_TITLE_IP)
          }
          if (state.data.director_reason.value !== DIRECTOR_REASON_IP) {
            _.set(newData, 'director_reason.value', DIRECTOR_REASON_IP)
          }
        }

        if (state.data.company_type.value !== data.company_type) {
          _.set(newData, 'inn.value', '')
        }
      }

      return { ...state, data: {...state.data, ...newData}}
    },
  }, 
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/details.js